import React, { useEffect } from "react";
import "./Experience.css";

const Experience = () => {
  useEffect(() => {
    const jobSections = document.querySelectorAll(".experience__job-section");
    const observer = new IntersectionObserver((entries) => {
      console.log(entries);
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove("experience__invisible");
        } else {
          entry.target.classList.add("experience__invisible");
        }
      });
    });

    jobSections.forEach((jobSect) => observer.observe(jobSect));
  }, []);
  return (
    <div className="section" id="experience">
      <div>
        <div className="section-header">Experience</div>
        <div className="experience__container">
          <div className="experience__job-section experience__invisible">
            <div className="experience__header">
              Pangea
              <span className="experience__header-adjacent">
                <div className="experience__position">
                  Fullstack Web Developer
                </div>
                <div className="experience__time">Present</div>
              </span>
            </div>
            <ul className="experience__desc-list">
              <li>
                {" "}
                • Developed a cryptocurrency user platform that analyzed data
                from NFT marketplaces and crypto exchanges
              </li>
              <li>
                • Implemented a cache to improve web application performance and
                significantly reduce server load
              </li>
              <li>
                • Automated data collection and enrichment for client’s
                application using CRON and interval based tasks
              </li>
              <li>
                • Created an application that gathered potential customer leads
                from different platforms to provide to small businesses{" "}
              </li>
            </ul>
          </div>
          <div className="experience__job-section experience__invisible">
            <div className="experience__header">
              IBM
              <span className="experience__header-adjacent">
                <div className="experience__position">
                  Extreme Blue, Front End Developer Intern
                </div>
                <div className="experience__time">May 2022 - Aug 2022</div>
              </span>
            </div>
            <ul className="experience__desc-list">
              <li>
                {" "}
                • Developed a cloud security tool that detected vulnerabilities
                in container images, clusters, and virtual machines
              </li>
              <li>
                • Created a data pipeline to analyze and create data
                visualizations from a massive unorganized data lake
              </li>
              <li>
                • Enriched data using internal APIs and transformed raw data to
                output key metrics that were previously incalculable
              </li>
              <li>
                • Implemented a sandbox interface that allowed users to
                visualize different variable pairs from the data lake
                dynamically
              </li>
              <li>
                • Integrated a machine learning model that predicted the time it
                would take to patch a vulnerability into a user interface
              </li>
              <li>
                • Submitted a patent disclosure for the cloud security
                monitoring tool’s novelty{" "}
              </li>
            </ul>
          </div>
          <div className="experience__job-section experience__invisible">
            <div className="experience__header">
              CSUEB
              <span className="experience__header-adjacent">
                <div className="experience__position">
                  XR/VR Research Tech Lead
                </div>
                <div className="experience__time">Aug 2021 - May 2022</div>
              </span>
            </div>
            <ul className="experience__desc-list">
              <li>
                {" "}
                • Developed Virtual Reality Applications with Unreal Engine 5
              </li>
              <li>
                • Tested motion tracking and stability of HTC Vive VR headset
                with Unreal Engine 5
              </li>
              <li>
                • Developed a navigable Solar System virtual environment that
                simulated planetary orbits and space travel
              </li>
            </ul>
          </div>
          <div className="experience__job-section experience__invisible">
            <div className="experience__header">
              Teamcal.ai
              <span className="experience__header-adjacent">
                <div className="experience__position">
                  Software Engineer Intern
                </div>
                <div className="experience__time">May 2021 - Aug 2021</div>
              </span>
            </div>
            <ul className="experience__desc-list">
              <li>
                {" "}
                • Rearchitected website into a content management system
                providing a no code solution to dynamically change content
              </li>
              <li>
                • Integrated a blog into marketing website which improved SEO
                quality
              </li>
              <li>
                • Developed a core product feature that automated meeting
                scheduling for managers and CEOs of large companies
              </li>
              <li>
                • Tested and debugged existing product features to ensure
                continuity of operation
              </li>
              <li>
                • Practiced AGILE methodologies to brainstorm, design, and
                develop new product features.
              </li>
            </ul>
          </div>
          <div className="experience__job-section experience__invisible">
            <div className="experience__header">
              Dev/Mission
              <span className="experience__header-adjacent">
                <div className="experience__position">
                  Pre-Apprenticeship Intern
                </div>
                <div className="experience__time">Feb 2021 - May 2021</div>
              </span>
            </div>
            <ul className="experience__desc-list">
              <li>
                {" "}
                • Demonstrated knowledge of IT Fundamentals(Hardware, Software,
                OS){" "}
              </li>
              <li>
                • Enhanced and applied programming skills by creating web
                applications ( HTML, CSS, JavaScript, jQuery, Bootstrap)
              </li>
              <li>
                • Programmed and constructed IoT(Internet of Things) devices
                (C++, Arduino, TinkerCAD)
              </li>
              <li>
                • Collaborated with other pre-apprentices to launch successful
                projects
              </li>
            </ul>
          </div>
          <div className="experience__job-section experience__invisible">
            <div className="experience__header">
              EMRCPR
              <span className="experience__header-adjacent">
                <div className="experience__position">IT Project Lead</div>
                <div className="experience__time">Sep 2019 - Mar 2021</div>
              </span>
            </div>
            <ul className="experience__desc-list">
              <li>
                {" "}
                • Supervised a group of technicians to setup and relocate
                desktops & data centers for different tech companies{" "}
              </li>
              <li>
                • Interacted consistently with clients to ensure satisfaction
                and project accuracy
              </li>
              <li>
                • Managed inventory and performed quality assurance to prepare
                materials and guarantee project success{" "}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
